interface props {
  count: number | undefined;
  color?: "errorLight" | "light" | "dark";
  className?: string;
  hideZero?: boolean;
}

export default function CountCircle({ count, color, className, hideZero }: props) {
  if (hideZero && count == 0) {
    return <></>;
  }
  return (
    <span
      className={`px-2.25 rounded-full text-lg font-bold ${
        color == "light"
          ? "bg-ldir-blue-100 text-ldir-blue-900"
          : color == "errorLight"
            ? "bg-ldir-red-700 text-ldir-red-900"
            : "bg-ldir-blue-900 text-ldir-blue-100"
      } ${className}`}
    >
      {count}
    </span>
  );
}
